'use client';
import Switch from '../UI/Switch';

export function ToggleItem({
  title,
  description,
  state,
  onChange,
  disabled
}: {
  title: string;
  description: string;
  state: boolean;
  onChange: () => void;
  disabled?: boolean;
}) {
  return (
    <div className="mt-4 flex w-full max-w-[660px] items-center justify-between rounded-md border border-ds-border-standard px-4 py-3">
      <div>
        <p>{title}</p>
        <span className="mt-1 block text-sm text-textSecondary">
          {description}
        </span>
      </div>
      <Switch disabled={disabled} state={state} onChange={onChange} />
    </div>
  );
}
